'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _iBem = require('../i-bem/i-bem.react');

var _bRadiobox = (require('./../radiobox/radiobox.react.js').default || require('./../radiobox/radiobox.react.js')).applyDecls();

var _bRadiobox2 = _interopRequireDefault(_bRadiobox);

var _eRadioMSideBoth = (require('./__radio/radio-button__radio.react.js').default || require('./__radio/radio-button__radio.react.js')).applyDecls();

var _eRadioMSideBoth2 = _interopRequireDefault(_eRadioMSideBoth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)(_bRadiobox2.default, {
    block: 'radio-button',
    content: function content(_ref) {
        var _this = this;

        var name = _ref.name,
            mainValue = _ref.value,
            mainDisabled = _ref.disabled,
            view = _ref.view,
            children = _ref.children;

        var num = _react.Children.count(children);

        return _react.Children.map(children, function (item, key) {
            var side = num === 1 ? 'both' : '';

            if (num > 1) {
                if (key === 0) {
                    side = 'left';
                }

                if (key === num - 1) {
                    side = 'right';
                }
            }

            return (0, _react.cloneElement)(item, {
                onChange: mainDisabled ? undefined : _this.onChange,
                mainDisabled: mainDisabled,
                mainValue: mainValue,
                name: name,
                side: view === 'default' ? undefined : side,
                key: key
            });
        });
    }
}, {
    Radio: _eRadioMSideBoth2.default
});